// SubscriptionModals.jsx
import React from 'react';
import PropTypes from 'prop-types';

import ModalView from '../container/ModalView.js';

import UniversalComponent from '../component/UniversalComponent.jsx';
import { ModalId } from '../resource/trackingConstants.js';

export const SubscriptionModals = ({ shopId = '' }) => {
  return (
    <>
      <ModalView
        id="SubscribeAndUnlockModal"
        render={() => (
          <UniversalComponent
            filename="Container_SubscribeAndUnlockModal"
            importer={
              /* #__LOADABLE__ */ () =>
                import('../container/SubscribeAndUnlockModal.js')
            }
          />
        )}
      />
      <ModalView
        id={`${shopId}.PaymentSourceSelector`}
        modalId={ModalId.DiamondShop.DiamondShopSelectPaymentMethod}
      >
        <UniversalComponent
          filename="Container_PaymentSourceSelector"
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/PaymentSourceSelector.js')
          }
          shopId={shopId}
        />
      </ModalView>
      <ModalView
        id={`${shopId}.SecurionpayCardFormModal`}
        modalId={ModalId.DiamondShop.DiamondShopCreditcardEnter}
      >
        <UniversalComponent
          filename="Container_SecurionpayCardFormModal"
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/SecurionpayCardFormModal.js')
          }
          shopId={shopId}
        />
      </ModalView>
      <ModalView
        id={`${shopId}.TappayCardFormModal`}
        modalId={ModalId.DiamondShop.DiamondShopCreditcardEnter}
      >
        <UniversalComponent
          filename="Container_TappayCardFormModal"
          importer={
            /* #__LOADABLE__ */ () =>
              import('../container/TappayCardFormModal.js')
          }
          shopId={shopId}
        />
      </ModalView>
    </>
  );
};

SubscriptionModals.propTypes = {
  shopId: PropTypes.string,
};

export default SubscriptionModals;
